import { mergeStyleSets } from "@fluentui/react";
import React, { useEffect, useState } from "react";
import ChangeLogList from "../../changelog.json";

type Log = {
  version: string;
  releaseDate: string;
  major: string[];
  minor: string[];
  bugFix: string[];
  data: string[];
};

const classes = mergeStyleSets({
  container: {
    height: "100%",
    overflow: "auto"
  },
  innerContainer: {
    maxWidth: 600,
    margin: "auto"
  },
  version: {
    marginBottom: 60
  },
  title: {
    fontSize: 24,
    lineHeight: 28,
    fontWeight: "bold",
    color: "rgb(76, 76, 76)",
    marginBottom: 10
  },
  subTitle: {
    fontSize: 16,
    lineHeight: 20,
    color: "rgb(76, 76, 76)",
    fontWeight: "bold",
    marginBottom: 10
  },
  releaseDate: {
    fontSize: 14,
    lineHeight: 20,
    color: "rgb(76, 76, 76)",
    marginBottom: 20,
    fontWeight: "bold"
  },
  item: {
    fontSize: 16,
    lineHeight: 20,
    color: "rgb(76, 76, 76)"
  }
});

const VersionPanel = (log: Log) => {
  return (
    <div className={classes.version}>
      <div className={classes.title}>Version {log.version}</div>
      <span className={classes.releaseDate}>{log.releaseDate}</span>

      {log.major && log.major.length > 0 && (
        <>
          <div className={classes.subTitle}>New:</div>
          <ul>
            {log.major.map(m => (
              <li className={classes.item}>{m}</li>
            ))}
          </ul>
        </>
      )}

      {log.minor && log.minor.length > 0 && (
        <>
          <span className={classes.subTitle}>Minor:</span>
          <ul>
            {log.minor.map(m => (
              <li className={classes.item}>{m}</li>
            ))}
          </ul>
        </>
      )}

      {log.bugFix && log.bugFix.length > 0 && (
        <>
          <div className={classes.subTitle}>Bug fix:</div>
          <ul>
            {log.bugFix.map(m => (
              <li className={classes.item}>{m}</li>
            ))}
          </ul>
        </>
      )}

      {log.data && log.data.length > 0 && (
        <>
          <div className={classes.subTitle}>Data:</div>
          <ul>
            {log.data.map(m => (
              <li className={classes.item}>{m}</li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

const ReleaseNotesPage = () => {
  const [changeLogs, setChangeLogs] = useState<Log[]>([]);

  useEffect(() => {
    const changeLogs = ChangeLogList.map(
      l =>
        ({
          version: l.version,
          releaseDate: l.releaseDate,
          major: l.major,
          minor: l.minor,
          bugFix: l.bugFix,
          data: l.data
        } as Log)
    );
    setChangeLogs(changeLogs.reverse());
  }, []);

  return (
    <div className={classes.container}>
      <div className={classes.innerContainer}>
        {changeLogs.map(l => (
          <VersionPanel key={l.version} {...l} />
        ))}
      </div>
    </div>
  );
};

export default ReleaseNotesPage;
